import BaseComponent from '../base-component/base-component'
import { checkMobileVersion } from '../../utils/check-media'

class ZoomCursor extends BaseComponent {
  zoomTargetSelector: string
  mutationObserver: MutationObserver
  checkTargetsIntervalID: number
  isHandlerSetted: boolean

  constructor() {
    super()

    this.zoomTargetSelector = `[data-zoom-cursor-target]`

    this.mutationObserver = new MutationObserver(this.handleMutations)
  }

  connectedCallback(): void {
    this.autoCheckTargets()
  }

  disconnectedCallback(): void {
    window.removeEventListener('mousemove', this.handleMouseMove)

    this.mutationObserver.disconnect()

    clearInterval(this.checkTargetsIntervalID)
  }

  handleMutations = (mutations): void => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') {
        const isZoomTarget = mutation.target.matches(this.zoomTargetSelector)

        this.setVisible(isZoomTarget)
      }
    })
  }

  handleMouseMove = (event: MouseEvent): void => {
    const target = event.target as HTMLElement
    const isZoomTarget = !!target.closest(this.zoomTargetSelector)
    const isMobile = checkMobileVersion()

    if (this.isVisible) {
      this.style.top = `${event.clientY}px`
      this.style.left = `${event.clientX}px`
    }

    if (!isMobile) {
      this.setVisible(isZoomTarget)

      if (isZoomTarget) {
        this.mutationObserver.observe(target, {
          attributes: true,
        })
      }
    }
  }

  setVisible(isVisible: boolean): void {
    this.toggleAttribute('visible', isVisible)

    document.body.style.cursor = isVisible ? 'none' : ''
  }

  updateState(isZoomed: boolean): void {
    this.toggleAttribute('zoomed', isZoomed)
  }

  autoCheckTargets(): void {
    this.checkTargetsIntervalID = setInterval(() => {
      const targets = document.querySelectorAll(this.zoomTargetSelector)

      if (targets.length && !this.isHandlerSetted) {
        window.addEventListener('mousemove', this.handleMouseMove)

        this.isHandlerSetted = true
      }
    }, 5000)
  }

  get isVisible(): boolean {
    return this.hasAttribute('visible')
  }
}

export default ZoomCursor
